import React from "react";
import { Row, Col } from "react-bootstrap";
import { Container } from "reactstrap";
import $ from "jquery";
import Lightbox from 'react-image-lightbox';
import { connect } from "react-redux";
import { fetchProjects } from "../Actions/projects";
import { withStyles } from '@material-ui/core/styles';
import { ProjectDetailsDialog } from ".";
import { Button } from "@material-ui/core";

class Portfolio extends React.Component {
    constructor() {
        super();
        this.state = {
            projects: [],
            xs: 6,
            isOpenLightBox: false,
            photoIndex: 0,
            projectIndex: 0,
            projectDescShow: false
        };
        this.closeModal = this.closeModal.bind(this);
        this.showLightBox = this.showLightBox.bind(this);
        this.closeLightBox = this.closeLightBox.bind(this);
    }
    componentWillMount = () => {
        this.fetchAndSaveProjectsToState();
    }
    componentDidMount = () => {
        if ($(window).width() < 575) this.setState({ xs: 12 });
        $(window).resize(_ => {
            if ($(window).width() < 575) this.setState({ xs: 12 });
            else this.setState({ xs: 6 });
        });
    }
    saveProjectsToState = (completeProjects) => {
        if (completeProjects) {
            this.setState({ projects: this.props.projects.projects });
        } else {
            this.setState({ projects: this.props.projects.projects.slice(0, 9) });
        }
    }
    fetchAndSaveProjectsToState = (completeProjects) => {
        this.props.fetchProjects().then(_ => {
            this.saveProjectsToState(completeProjects);
        });
    }
    showLightBox(i) {
        this.setState({
            projectDescShow: false,
            isOpenLightBox: true,
            photoIndex: i
        });
    }
    closeLightBox() {
        this.setState({ projectDescShow: true, isOpenLightBox: false });
    }
    closeModal() {
        this.setState({ projectDescShow: false });
    }
    render() {
        const { classes } = this.props;
        const { projects, projectIndex, photoIndex } = this.state;
        return (
            <div style={styles.portfolioContainer} className="portfolioContainer">
                <Container>
                    <h3 style={styles.portfolioRepresentationHeading}>Portfolio</h3>
                    <p style={styles.portfolioRepresentationPara}>Here are all of my projects that I've done up till now, some of them are for clients and some are of mine personal projects.</p>
                    <Row>
                        {this.state.projects.map((eachProject, i) => (
                            <Col style={styles.eachProjectShower} key={i} xs={this.state.xs} sm={6} md={4} className="eachProjectShower">
                                <img src={eachProject.images[0]} style={styles.eachProjectShowerIMG} alt="projectFirstImage" className="eachProjectImg" />
                                <div style={styles.projectOverlay} onClick={_ => { this.setState({ projectDescShow: true, projectIndex: i, photoIndex: 0 }); }} className="projectOverlay">
                                    <Button className={classes.button} style={styles.eachProjectShowerBTN}>Details</Button>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    {(this.props.projects.projects.length > 9 && projects.length <= 9) && <p style={styles.moreProjectShower} onClick={_ => { this.saveProjectsToState(true) }}>Show More</p>}
                    {projects.length > 9 && <p style={styles.moreProjectShower} onClick={_ => { this.saveProjectsToState(false) }}>Show Less</p>}
                    {this.state.isOpenLightBox && <Lightbox
                        mainSrc={projects[projectIndex].images[photoIndex]}
                        nextSrc={projects[projectIndex].images[photoIndex + 1]}
                        prevSrc={projects[projectIndex].images[photoIndex - 1]}
                        onCloseRequest={this.closeLightBox}
                        onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex - 1),
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + 1) % projects[projectIndex].images.length,
                            })
                        }
                    />}
                    <ProjectDetailsDialog data={this.state.projects[this.state.projectIndex]} projectDescShow={this.state.projectDescShow} classes={classes} closeModal={this.closeModal} showLightBox={this.showLightBox} />
                </Container>
            </div>
        );
    }
}

const styles = {
    portfolioContainer: {
        backgroundColor: "black",
        fontFamily: "Roboto, sans-serif",
        paddingTop: 100,
        textAlign: "center",
        position: "relative",
        paddingBottom: 80
    },
    portfolioRepresentationHeading: {
        color: "#f1f1f1",
        fontSize: 30,
        fontWeight: 700,
        margin: 0,
        textTransform: "uppercase",
        letterSpacing: 2,
        marginBottom: 40
    },
    portfolioRepresentationPara: {
        fontSize: 16,
        color: "#929292"
    },
    eachProjectShower: {
        marginTop: 30,
        height: 200
    },
    eachProjectShowerIMG: {
        width: "100%",
        height: "inherit",
        transition: 'all .40s ease'
    },
    projectOverlay: {
        position: "absolute",
        top: 0,
        left: "5%",
        right: 0,
        bottom: 0,
        height: "100%",
        width: "91%",
        opacity: 0,
        transition: "all 0.40s ease"
    },
    eachProjectShowerBTN: {
        position: "absolute",
        top: "40%",
        left: "35%",
        tranform: "tranlate(-50%, -50%)",
        msTransform: "translate(-50%, -50%)"
    },
    moreProjectShower: {
        marginTop: 10,
        color: "#bdc3c7",
        fontSize: 16,
        cursor: "pointer"
    }
};

const styles2 = theme => ({
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
        fontWeight: 'bold',
        fontFamily: 'Roboto, sans-serif',
        fontSize: 18
    },
    button: {
        margin: theme.spacing.unit,
        color: '#fff',
        fontSize: 14
    }
});

export default connect(state => ({ projects: state.projects }), { fetchProjects })(withStyles(styles2)(Portfolio));


// WEBPACK FOOTER //
// ./src/Components/portfolio.jsx